import { useExperiment } from "../../../../../../../hooks/experiments";
import type { QuestionComponentProps } from "../../types";
import { PersonalisedCoverQuestion as Treatment } from "./ExperimentInsuranceAssistantQ2q/PersonalisedCoverQuestion";
import { PersonalisedCoverQuestion as Control } from "./PersonalisedCoverQuestion";

export const PersonalisedCoverQuestion = (props: QuestionComponentProps) => {
  const isInsuranceAssistant =
    useExperiment("uk2603InsuranceAssistantQ2q") === "treatment";

  if (isInsuranceAssistant) {
    return <Treatment {...props} />;
  }

  return <Control {...props} />;
};
